<div class="gp">
  <div class="gp__bar">
    <app-search-input
      class="gp__search"
      [placeholder]="'Search ' + nounPlural + ' by name'"
      [debounce]="300"
      (valueChange)="onSearch($event)"
    />
    <p class="gp__count" aria-live="polite">
      @if (selectedCount) {
        <span class="gp__count-num">{{ selectedCount }}</span> selected
        <button type="button" class="gp__clear" (click)="clearSelection()">Clear</button>
      } @else {
        None selected
      }
    </p>
  </div>

  <!-- Always present, so screen readers hear each change. -->
  <p class="bk-sr-only" role="status">{{ statusText }}</p>

  @if (createdName) {
    <p class="gp__note">
      <span class="bk-sym" aria-hidden="true">check</span>
      Created “{{ createdName }}” and selected it.
    </p>
  }

  @if (showCreate) {
    <form class="gp__create" (ngSubmit)="createTag()">
      <p class="gp__create-title">New tag</p>
      <div class="gp__create-fields">
        <div class="bk-field">
          <label class="bk-field__label" for="gp-new-name">Name</label>
          <input
            id="gp-new-name"
            class="bk-field__input"
            name="newName"
            [(ngModel)]="newName"
            [attr.aria-invalid]="createError ? 'true' : null"
            autocomplete="off"
          />
        </div>
        <div class="bk-field">
          <label class="bk-field__label" for="gp-new-desc">Description (optional)</label>
          <input id="gp-new-desc" class="bk-field__input" name="newDescription" [(ngModel)]="newDescription" autocomplete="off" />
        </div>
      </div>
      @if (createError) {
        <p class="bk-field__error"><span class="bk-sym" aria-hidden="true">error</span>{{ createError }}</p>
      }
      <div class="gp__create-actions">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="cancelCreate()">Cancel</button>
        <button type="submit" class="bk-btn bk-btn--primary" [disabled]="creating">
          {{ creating ? 'Creating…' : 'Create and select' }}
        </button>
      </div>
    </form>
  } @else if (canOfferCreate) {
    <button type="button" class="gp__offer" (click)="openCreate()">
      <span class="bk-sym" aria-hidden="true">add</span>
      Create tag “{{ term.trim() }}”
    </button>
  }

  <div class="bk-panel gp__panel" [attr.aria-busy]="loading">
    @if (loadError) {
      <div class="gp__state">
        <p class="gp__state-text">{{ loadError }}</p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="retry()">Try again</button>
      </div>
    } @else if (loading && !items.length) {
      <div class="gp__skel" aria-hidden="true">
        @for (row of [1, 2, 3, 4, 5]; track row) {
          <span class="bk-skel gp__skel-row"></span>
        }
      </div>
    } @else if (!items.length) {
      <div class="gp__state">
        <p class="gp__state-text">
          @if (term.trim()) {
            No {{ nounPlural }} match “{{ term.trim() }}”.
          } @else {
            No {{ nounPlural }} yet. Create one from the {{ kind === 'tag' ? 'Tags' : 'Organizations' }} tab first.
          }
        </p>
      </div>
    } @else {
      <table class="bk-log gp__table" [class.is-loading]="loading">
        <thead>
          <tr>
            <th scope="col" class="gp__check">
              <input
                type="checkbox"
                [checked]="allOnPageChosen"
                [indeterminate]="someOnPageChosen"
                (change)="toggleAllOnPage()"
                [attr.aria-label]="'Select every ' + noun + ' on this page'"
              />
            </th>
            <th scope="col">Name</th>
            @if (kind === 'organization') {
              <th scope="col" class="gp__col-2">Industry</th>
              <th scope="col" class="gp__col-3">Country</th>
            } @else {
              <th scope="col" class="gp__col-2">Created</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of items; track keyOf(item)) {
            <tr class="gp__row" [class.is-chosen]="isChosen(item)" (click)="toggle(item)">
              <td class="gp__check">
                <input
                  type="checkbox"
                  [checked]="isChosen(item)"
                  (click)="$event.stopPropagation()"
                  (change)="toggle(item)"
                  [attr.aria-label]="'Select ' + (item.name || noun)"
                />
              </td>
              <td class="gp__name">
                <span class="bk-msg">
                  <span class="bk-msg__subject">{{ item.name || 'Untitled ' + noun }}</span>
                  @if (description(item)) {
                    <span class="bk-msg__preview">{{ description(item) }}</span>
                  }
                </span>
              </td>
              @if (kind === 'organization') {
                <td class="quiet gp__col-2">{{ industry(item) }}</td>
                <td class="quiet gp__col-3">{{ country(item) }}</td>
              } @else {
                <td class="quiet gp__col-2">{{ created(item) }}</td>
              }
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  @if (totalPages > 1) {
    <nav class="gp__pager" [attr.aria-label]="nounPlural + ' pages'">
      <span class="gp__range">{{ rangeLabel }}</span>
      <span class="gp__pager-btns">
        <button
          type="button"
          class="bk-icon-btn"
          aria-label="Previous page"
          [disabled]="page === 0 || loading"
          (click)="goTo(page - 1)"
        >
          <span class="bk-sym" aria-hidden="true">chevron_left</span>
        </button>
        <span class="gp__page">Page {{ page + 1 }} of {{ totalPages }}</span>
        <button
          type="button"
          class="bk-icon-btn"
          aria-label="Next page"
          [disabled]="page >= totalPages - 1 || loading"
          (click)="goTo(page + 1)"
        >
          <span class="bk-sym" aria-hidden="true">chevron_right</span>
        </button>
      </span>
    </nav>
  }
</div>
